"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var WebAnalytics = _interopRequireWildcard(require("@adsk/acs-web-analytics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useAnalytics = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    eventNamePrefix,
    service
  } = props;
  (0, _react.useEffect)(() => {
    WebAnalytics.setBaseProperties({
      service
    });
  }, [service]);
  return {
    trackEvent: buildTrackEvent(eventNamePrefix)
  };
};
const buildTrackEvent = eventNamePrefix => {
  return _ref => {
    let {
      eventName,
      details
    } = _ref;
    try {
      if (!eventName && !eventNamePrefix) {
        console.warn(`Event ${eventNamePrefix} ${eventName} not tracked`);
        return;
      }
      const eventSpecificProps = details || {};
      const prefix = eventNamePrefix ? `.${eventNamePrefix}` : '';
      WebAnalytics.track(`reports${prefix}.${eventName}`, {
        ...eventSpecificProps,
        origin: eventNamePrefix
      });
    } catch {
      console.warn(`Event ${eventName} not tracked`);
    }
  };
};
var _default = exports.default = useAnalytics;